import React from 'react'
import InitialAvatar from 'shared/components/InitialAvatar/InitialAvatar'
import { ReactComponent as BellIcon } from 'assets/icons/bell.svg'
import { ReactComponent as CheckIcon } from 'assets/icons/check.svg'
import { ReactComponent as StarsIcon } from 'assets/icons/stars-2.svg'
import AutoGrowTextarea from './AutoGrowTextarea'
import s from '../NoteTakerDrawer.module.scss'

const ActionItemRow = ({
	item,
	studentName,
	studentId,
	onTextChange,
	onToggleDone,
	onDelete,
	onAskKoda,
	onRemind,
}) => {
	const isStudentOwned = item.ownerType === 'student'
	const ownerLabel = isStudentOwned ? studentName.split(' ')[0] : 'You'
	const actionLabel = isStudentOwned ? 'Remind' : 'Ask Koda'
	const isDone = item.status === 'done'
	const hasText = Boolean(String(item.text || '').trim())

	const handleAction = () => {
		if (isStudentOwned) {
			onRemind?.(item)
		} else {
			onAskKoda?.(item)
		}
	}

	return (
		<div className={[s.actionRow, isDone ? s.actionRowDone : ''].filter(Boolean).join(' ')}>
			<button
				type="button"
				className={s.checkboxButton}
				aria-label={isDone ? 'Mark action item open' : 'Mark action item done'}
				onClick={() => onToggleDone(item.id)}
			>
				<span className={s.checkbox}>{isDone ? <CheckIcon /> : null}</span>
			</button>
			<div className={s.actionTextGroup}>
				<div className={s.actionMainRow}>
					<div className={s.ownerPill}>
						<InitialAvatar
							name={ownerLabel}
							size={22}
							studentId={isStudentOwned ? studentId : undefined}
						/>
						<span>{ownerLabel}:</span>
					</div>
					<div className={s.actionInputWrap}>
						<AutoGrowTextarea
							className={s.actionInput}
							value={item.text}
							onChange={event => onTextChange(item.id, event.target.value)}
						/>
					</div>
				</div>
				{item.dueHint ? (
					<span className={s.actionDueHint}>Due: {item.dueHint}</span>
				) : null}
				{item.saveStatus === 'saving' ? (
					<span className={s.rowSaving}>Saving...</span>
				) : null}
				{item.saveError ? (
					<span className={s.inlineError}>{item.saveError.message}</span>
				) : null}
			</div>
			<button
				type="button"
				className={s.actionButton}
				disabled={!hasText}
				title={
					hasText
						? actionLabel
						: 'Add text to this action item first'
				}
				onClick={handleAction}
			>
				{isStudentOwned ? <BellIcon /> : <StarsIcon />}
				<span>{actionLabel}</span>
			</button>
			<button
				type="button"
				className={s.deleteItemButton}
				aria-label="Delete action item"
				onClick={() => onDelete(item.id)}
			>
				×
			</button>
		</div>
	)
}

export default ActionItemRow
